/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Unchanged_Stamp_HintInputs */

const cs_ebr_unchanged_stamp_hint = /** @type {(inputs: Ebr_Unchanged_Stamp_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beze změny: razítko změny v eBráně je stejné jako při posledním importu a propojení v CRM je v pořádku, nabídka se proto znovu nenačítá.`)
};

const en_ebr_unchanged_stamp_hint = /** @type {(inputs: Ebr_Unchanged_Stamp_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unchanged: the eBrána change stamp equals the last import and the CRM link is correct, so the offer is not re-read.`)
};

/**
* | output |
* | --- |
* | "Unchanged: the eBrána change stamp equals the last import and the CRM link is correct, so the offer is not re-read." |
*
* @param {Ebr_Unchanged_Stamp_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_unchanged_stamp_hint = /** @type {((inputs?: Ebr_Unchanged_Stamp_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Unchanged_Stamp_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_unchanged_stamp_hint(inputs)
	return cs_ebr_unchanged_stamp_hint(inputs)
});